import React, { useMemo, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from '@ui/molecules/Modal';
import { SelectInput } from '@ui/molecules/inputs/form/SelectInput/SelectInput';
import { InlineNotification } from '@ui/molecules/InlineNotification';
import { Button } from '@ui/atoms/Button';
import { Loader } from '@ui/atoms/Loader';
import { Text } from '@ui/atoms/Text';
import { translate } from '@utils/i18n';
import { NAMESPACE } from '../constants';
function AcceptByTechnicianModal({ isOpen, isSubmitting, isLoading, hasError, summary, onClose, onConfirm }) {
    const [technicianId, setTechnicianId] = useState(null);
    const options = useMemo(() => { var _a; return ((_a = summary === null || summary === void 0 ? void 0 : summary.technicians) !== null && _a !== void 0 ? _a : []).map(({ id, name }) => ({ label: name, value: id })); }, [summary]);
    const selected = useMemo(() => { var _a; return (_a = summary === null || summary === void 0 ? void 0 : summary.technicians.find((technician) => technician.id === technicianId)) !== null && _a !== void 0 ? _a : null; }, [summary, technicianId]);
    const handleClose = () => {
        setTechnicianId(null);
        onClose();
    };
    return (React.createElement(Modal, { isOpen: isOpen, onClose: handleClose, ariaLabel: translate('modal_title', { namespace: NAMESPACE }) },
        React.createElement(ModalHeader, { title: translate('modal_title', { namespace: NAMESPACE }) }),
        React.createElement(ModalBody, null,
            isLoading && React.createElement(Loader, null),
            hasError && (React.createElement(InlineNotification, { variant: "error" }, translate('load_error', { namespace: NAMESPACE }))),
            !isLoading && !hasError && summary && (React.createElement(React.Fragment, null,
                React.createElement(SelectInput, { label: translate('technician_label', { namespace: NAMESPACE }), options: options, value: technicianId !== null && technicianId !== void 0 ? technicianId : undefined, onChange: (value) => setTechnicianId(value) }),
                selected && (React.createElement(Text, { variant: "body", as: "p" }, selected.groupsResolvable === 0
                    ? translate('summary_none', { namespace: NAMESPACE })
                    : translate('summary', {
                        namespace: NAMESPACE,
                        resolvable: selected.groupsResolvable,
                        total: summary.groupsTotal
                    })))))),
        React.createElement(ModalFooter, null,
            React.createElement(Button, { variant: "secondary", type: "button", onClick: handleClose, disabled: isSubmitting }, translate('cancel', { namespace: NAMESPACE })),
            React.createElement(Button, { variant: "primary", type: "button", disabled: selected === null || selected.groupsResolvable === 0 || isSubmitting, onClick: () => {
                    if (selected)
                        void onConfirm(selected.id);
                } }, translate('confirm', { namespace: NAMESPACE })))));
}
export default AcceptByTechnicianModal;
